
import { AxiosInstance } from "axios";
import { generateQueryString } from 'src/util/helper';
import { PendencyCategoryTypeEnum } from '../Enum/pendency/PendencyCategoryTypeEnum';
import { ITradePendency } from '../interfaces/pendency/ITradePendency';
import { ITradePendencyCategory } from '../interfaces/pendency/ITradePendencyCategory';
import { IUpdatePendenciesRequest } from '../interfaces/pendency/IUpdatePendenciesRequest';
import { IUploadFile } from "../interfaces/pendency/IUploadFile";
import { ApiService } from '../models/Api.model';
import { IBaseResponse } from './IBaseResponse';

enum PendencyServiceEnum {
  updatePendencies = "/update-pendencies",
  getPendencyCategories = "/get-pendency-categories?",
  getPendenciesByTradeId = "/get-pendencies-by-trade-id/",
  uploadPendencySolutionFile = "/upload-solution-file"
}
export default class PendencyService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/trade/pendency");
  }

  public uploadPendencySolutionFile = async (pendencyId: number, data: IUploadFile): Promise<IBaseResponse> => await this.POST(`${PendencyServiceEnum.uploadPendencySolutionFile}/${pendencyId}`, data);
  public updatePendencies = async (data: IUpdatePendenciesRequest): Promise<IBaseResponse> => await this.PUT(PendencyServiceEnum.updatePendencies, data);
  public getPendencyCategories = async (types: PendencyCategoryTypeEnum[]): Promise<ITradePendencyCategory[]> =>
    await this.GET(`${PendencyServiceEnum.getPendencyCategories}${generateQueryString({ types })}`);
  public getPendenciesByTradeId = async (tradeId: number): Promise<ITradePendency[]> => await this.GET(PendencyServiceEnum.getPendenciesByTradeId + tradeId);
}



// WEBPACK FOOTER //
// ./src/services/api/Pendency.service.ts